import { gql } from "@apollo/client";

export const GET_EXPERIENCE = gql`
  query experience($id: ExperienceID!) {
    experience(experienceId: $id) {
      name
      excludedCategories
      includedCategories
      deployedAt
      id
      uuid
      settings
      isMonitorable
      analyticsName
      deployedAt
      collection {
        id
        name
        settings
      }
      type
    }
  }
`;
